<template>
  <form class="driver-filters" @submit.prevent="applyFilters">
    <div class="search">
      <div class="title">DRIVER SEARCH:</div>
      <input type="text" placeholder="Type and hit enter to search." v-model="filterSearch"/>
    </div>

    <div class="service-types" v-if="useOldQuatation">
      <div class="title">SERVICE TYPE FILTERS:</div>
      <div class="row">
        <div class="small-4 columns end">
          <label>
            <input type="checkbox" value="shared" v-model="filterServiceTypes" />
            <span>{{ serviceLabel('shared') }} ({{ serviceCount['shared'] }})</span>
          </label>
        </div>
        <div class="small-4 columns end">
          <label>
            <input type="checkbox" value="opoli" v-model="filterServiceTypes" />
            <span>{{ serviceLabel('opoli') }} ({{ serviceCount['opoli'] }})</span>
          </label>
        </div>
        <div class="small-4 columns end">
          <label>
            <input type="checkbox" value="black" v-model="filterServiceTypes" />
            <span>{{ serviceLabel('black') }} ({{ serviceCount['black'] }})</span>
          </label>
        </div>
        <div class="small-4 columns end">
          <label>
            <input type="checkbox" value="suv" v-model="filterServiceTypes" />
            <span>{{ serviceLabel('suv') }} ({{ serviceCount['suv'] }})</span>
          </label>
        </div>
        <div class="small-4 columns end">
          <label>
            <input type="checkbox" value="shuttle" v-model="filterServiceTypes" />
            <span>{{ serviceLabel('shuttle') }} ({{ serviceCount['shuttle'] }})</span>
          </label>
        </div>
      </div>
      <button v-bind:class="{ 'cta small block success': true, disabled: applyingFilters }">
        <span v-show="!applyingFilters">APPLY FILTER</span>
        <i class="fas fa-spinner fa-spin" v-show="applyingFilters"></i>
      </button>
    </div>
    <div v-else>
      <div v-bind:class="{ 'button xsmall block service-type-filter': true, disabled: applyingFilters }" @click="showServiceFilterModal">
        <span>SERVICE TYPE FILTER</span>
      </div>
      <button v-bind:class="{ 'cta small block success': true, disabled: applyingFilters }">
        <span v-show="!applyingFilters">APPLY FILTER</span>
        <i class="fas fa-spinner fa-spin" v-show="applyingFilters"></i>
      </button>
    </div>

  </form>
</template>

<script>
/* global CONFIG */
import services from '@/modules/api/services'
import ApiDispatchDrivers from '@/modules/api/dispatch/drivers'
export default {
  name: 'driver-list-filters',
  data () {
    return {
      applyingFilters: false
    }
  },
  computed: {
    filterSearch: {
      get () { return this.$store.state.dispatch.driverListFilters.search },
      set (value) { this.$store.commit('dispatch/setDriverListSearchFilter', value)}
    },
    filterServiceTypes: {
      get () { return this.$store.state.dispatch.driverListFilters.serviceTypes },
      set (value) { this.$store.commit('dispatch/setDriverListServiceTypeFilter', value) }
    },
    serviceCount () { return this.$store.state.dispatch.serviceCount },
    useOldQuatation () { return CONFIG.useOldQuatation },
    _serviceFilterLoading () { return this.$store.state.dispatch.serviceFilter.loading }
  },
  methods: {
    applyFilters () {
      let self = this
      self.applyingFilters = true
      let openedDriverTable = self.$store.state.dispatch.driverListTabIndex
      let pageNumberMutation = 'dispatch/setOnDutyPageNumber'
      if (openedDriverTable === 1) {
        pageNumberMutation = 'dispatch/setStagingPageNumber'
      }
      if (openedDriverTable === 2) {
        pageNumberMutation = 'dispatch/setOffDutyPageNumber'
      }
      // Reset everything to page 1
      self.$store.commit(pageNumberMutation, 1)

      // ApiDispatchDrivers.getDriverList(self, openedDriverTable === 0, openedDriverTable === 1, r => {
        // self.applyingFilters = false
        // if (r.error) {
          // console.log(r)
          // return
        // }
        // self.$plugins.smoothScroll.scrollTo(document.getElementById('driver-list-container'))

        // let mutation = 'dispatch/setOnDutyNoDriversFound'
        // if (openedDriverTable === 1) {
          // mutation = 'dispatch/setStagingNoDriversFound'
        // }
        // if (openedDriverTable === 2) {
          // mutation = 'dispatch/setOffDutyNoDriversFound'
        // }
        // self.$store.commit(mutation, r.list.length <= 0)
      // })
      let data = {
        onDuty: openedDriverTable === 0,
        isStaging: openedDriverTable === 1
      }
      ApiDispatchDrivers.getDriverListV2(self, data, r => {
        self.applyingFilters = false
        if (r.error) {
          console.log(r)
          return
        }
        self.$plugins.smoothScroll.scrollTo(document.getElementById('driver-list-container'))

        let mutation = 'dispatch/setOnDutyNoDriversFound'
        if (openedDriverTable === 1) {
          mutation = 'dispatch/setStagingNoDriversFound'
        }
        if (openedDriverTable === 2) {
          mutation = 'dispatch/setOffDutyNoDriversFound'
        }
        self.$store.commit(mutation, r.list.length <= 0)
      })
    },
    serviceLabel (code) { return services.getServiceName(code) },
    showServiceFilterModal () {
      this.$store.commit('dispatch/setServiceFilterShow', true)
    }
  },
  watch: {
    _serviceFilterLoading (value) { this.applyingFilters = value }
  },
  mounted () {
    // let self = this
    // self.$nextTick(() => {
    //   self.applyFilters()
    // })
  }
}
</script>

<style lang="scss" scoped>
.driver-filters{
  padding: 50px 15px 15px;
  border-left: 1px solid rgba(0,0,0,0.2);
  border-right: 1px solid rgba(0,0,0,0.2);
  border-bottom: 1px solid rgba(0,0,0,0.2);
  background-color: #fff;
  & .title{
    color: #8DA0A9;
    font-size: 12px;
    font-weight: 700;
    margin-bottom: 5px;
    margin-top: 15px;
  }

  & input {
    line-height: inherit;
    font-size: 14px;
    margin-top: 0;
    background-color: #f5f5f5;
  }


  & .service-types {
    & label {
      display: block;

      & * {
        display: inline-block;
        margin-top: 0;
        width: auto;
      }
    }

    & span { font-size: 14px; }
  }

  & button {
    margin-top: 10px;
  }
}

.service-type-filter{
  margin-top: 10px;
}

.divider{
  width: 100%;
  border-top: 1px solid rgba(0,0,0,0.15);
  margin: 10px auto 15px;
}

@media only screen and (max-width: 430px) {
  .driver-filters{
    padding-top: 40px;
    .title {
      margin-top: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dispatch/DriverListFilters.vue